export type ThemeType = 'light' | 'dark' | 'system'
export enum ThemeVariant {
    LIGHT = 'light',
    DARK = 'dark',
    SYSTEM = 'system',
}
